module.exports = __webpack_public_path__ + "img/wsczzhjkyypt5.64063893.png";